import type { ComponentProps, DragEvent } from "react";
import { TextArea } from "./input";

interface FileDropTextAreaProps
  extends Omit<
    ComponentProps<typeof TextArea>,
    "onChange" | "onDragOver" | "onDrop"
  > {
  onValueChange: (value: string) => void;
}

export const FileDropTextArea = ({
  onValueChange,
  ...props
}: FileDropTextAreaProps) => {
  const handleDragOver = (event: DragEvent<HTMLTextAreaElement>) => {
    event.preventDefault();
    event.stopPropagation();
    event.dataTransfer.dropEffect = "copy";
  };

  const handleDrop = (event: DragEvent<HTMLTextAreaElement>) => {
    event.preventDefault();
    event.stopPropagation();

    const files = Array.from(event.dataTransfer.files);
    if (files.length === 0) return;

    Promise.all(files.map((file) => file.text()))
      .then((contents) => {
        onValueChange(contents.join("\n"));
      })
      .catch(() => undefined);
  };

  return (
    <TextArea
      {...props}
      onChange={(event) => onValueChange(event.currentTarget.value)}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    />
  );
};
